<template>
  <section class="relative z-20 -mt-[120px]">
    <div class="container mx-auto px-4">
      <div class="flex justify-center items-center gap-8 md:gap-16 lg:gap-24">
        <!-- Phone box (blue block) -->
        <div class="bg-gascon-blue text-white font-raleway flex flex-col items-center justify-center p-4 shadow-xl" style="width: 320px; height: 240px;">
          <p class="text-sm mb-1">Grossiste</p>
          <p class="text-sm mb-1">& Distributeur</p>
          <p class="text-sm mb-2">de produits choisis</p>
          <a href="tel:0678649816" class="text-base md:text-lg font-bold hover:opacity-80 transition-opacity">
            06 78 64 98 16
          </a>
        </div>

        <!-- Meat image -->
        <div class="shadow-xl overflow-hidden" style="width: 320px; height: 240px;">
          <img
            src="/images/filetsdecanette.png"
            alt="Manipulation de viande"
            class="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PhoneImageSection'
}
</script>
